(function () {
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-menu]');

    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });

    menu.addEventListener('click', function (event) {
      if (event.target.tagName !== 'A') return;
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function initCompare() {
    document.querySelectorAll('[data-compare]').forEach(function (compare) {
      var range = compare.querySelector('.azw-compare__range');
      if (!range) return;

      function update() {
        compare.style.setProperty('--compare-position', range.value + '%');
      }

      range.addEventListener('input', update);
      update();
    });
  }

  function initTestimonials() {
    document.querySelectorAll('[data-testimonials]').forEach(function (shell) {
      var track = shell.querySelector('.azw-testimonials__track');
      var prev = shell.querySelector('[data-testimonial-prev]');
      var next = shell.querySelector('[data-testimonial-next]');

      if (!track || !prev || !next) return;

      function cardWidth() {
        var card = track.querySelector('[data-testimonial-card]');
        return card ? card.getBoundingClientRect().width + 24 : 320;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.remove('no-js');
    initMenu();
    initCompare();
    initTestimonials();
  });
})();
